// extracted by mini-css-extract-plugin
module.exports = {"customBtn":"PermitDocuments_customBtn__29wMy"};